import Vue from 'vue'
import Router from 'vue-router'
import login from './login/login.vue'
import index from './base.vue'
import about from './about.vue'
import demuSynopsis from './demuSynopsis.vue'

Vue.component('home',() => import( /* webpackChunkName: "Home" */ './view/home/home.vue'));
Vue.component('enterprise',() => import( /* webpackChunkName: "enterprise" */ './view/enterprise/index.vue'));                    // 在线企业服务
Vue.component('supplyChain',() => import( /* webpackChunkName: "supplyChain" */ './view/enterprise/supplyChain/index.vue'));      // 松木ERP系统
Vue.component('warehouseChain',() => import( /* webpackChunkName: "warehouseChain" */ './view/enterprise/warehouseChain/index.vue'));// 仓库WMS系统
Vue.component('vehicleChain',() => import( /* webpackChunkName: "vehicleChain" */ './view/enterprise/vehicleChain/index.vue'));   // 车辆QMS系统
Vue.component('financeChain',() => import( /* webpackChunkName: "financeChain" */ './view/enterprise/financeChain/index.vue'));   // 金融FS系统
Vue.component('pumuChain',() => import( /* webpackChunkName: "pumuChain" */ './view/enterprise/pumuChain/index.vue'));            // 硬木ERP系统

Vue.component('freeTrial',() => import( /* webpackChunkName: "freeTrial" */ './view/freeTrial/index.vue'));                       // 供应链服务
Vue.component('spotFinanc',() => import( /* webpackChunkName: "spotFinanc" */ './view/freeTrial/spotFinanc/index.vue'));          // 现货融
Vue.component('orderFinanc',() => import( /* webpackChunkName: "orderFinanc" */ './view/freeTrial/orderFinanc/index.vue'));       // 供应链服务
Vue.component('goodsFinanc',() => import( /* webpackChunkName: "goodsFinanc" */ './view/freeTrial/goodsFinanc/index.vue'));       // 供应链服务

Vue.component('dataCon',() => import( /* webpackChunkName: "data" */ './view/data/index.vue'));                                   // 数据服务

Vue.component('productPrice',() => import( /* webpackChunkName: "productPrice" */ './view/productPrice/index.vue'));              // 产品价格
Vue.component('supplyPrice',() => import( /* webpackChunkName: "supplyPrice" */ './view/productPrice/supplyChain/index.vue'));      // 松木ERP价格
Vue.component('warehousePrice',() => import( /* webpackChunkName: "warehousePrice" */ './view/productPrice/warehouseChain/index.vue'));// 仓库WMS价格
Vue.component('financePrice',() => import( /* webpackChunkName: "financePrice" */ './view/productPrice/financeChain/index.vue'));   // 金融FS价格
Vue.component('pumuPrice',() => import( /* webpackChunkName: "pumuPrice" */ './view/productPrice/pumuChain/index.vue'));            // 硬木ERP价格
Vue.component('cloudChainPrice',() => import( /* webpackChunkName: "cloudChainPrice" */ './view/productPrice/cloudChainChain/index.vue'));// 德木云链价格

Vue.component('cloudChain',() => import( /* webpackChunkName: "cloudChain" */ './view/cloudChain/index.vue'));         // 德木云链

Vue.component('contact',() => import( /* webpackChunkName: "contact" */ './view/about/contact.vue'));                  // 关于我们 (联系我们)
Vue.component('cooperation',() => import( /* webpackChunkName: "cooperation" */ './view/about/cooperation.vue'));      // 企业合作
Vue.component('introduce',() => import( /* webpackChunkName: "introduce" */ './view/about/introduce.vue'));            // 公司介绍

// 工具
Vue.component('hpBottom',() => import( /* webpackChunkName: "hpBottom" */ './components/hpBottom.vue'));
Vue.component('kpBottom',() => import( /* webpackChunkName: "kpBottom" */ './components/kpBottom.vue'));
Vue.component('kpTable',() => import( /* webpackChunkName: "kpTable" */ './components/table.vue'));

Vue.use(Router)
export default new Router({
    routes: [
        {path: '/',redirect:"/index"},
        {path:"/login",name:"login",component:login},
        {path:"/index",name:"index",component:index},
        {path:"/about",name:"about",component:about},
        {path:"/demu",name:"synopsis",component:demuSynopsis},
    ]
})